import { Component } from 'preact';
import PropTypes from 'prop-types';
import CSSTransition from 'react-transition-group/CSSTransition';
import classNames from 'classnames';
import BaseSection from '../Base';
import Icon from '../../Global/Icon';
import * as icons from '../../../assets/icons';

// Components
import CurrentProgress from '../CurrentProgress';
import ProgressBar from '../../ProgressBar';


class InsuranceSection extends Component {
  constructor(props) {
    super(props);
    this.onExitingCallback = this.onExitingCallback.bind(this);
  }
  componentDidMount() {
    document.body.classList.add('footer-control-normal', 'header-close');
    document.body.classList.remove('footer-control', 'footer-control-close', 'footer-control-open', 'header-open', 'header-normal');
  }
  onExitingCallback(node) {
    const { error } = this.props;
    // CSS transtition will not finish its cycle on error. Force a reset in that case.
    if (error) {
      node.classList.remove('price-exit');
      node.classList.remove('price-exit-active');
    }
  }
  render() {
    const {
      actions,
      price,
      loaderProgress,
      currentSectionId,
      finishedSections,
      packageData,
      sectionOrder,
      currentProgress,
      userData,
      activeSectionData,
      currentProgress: {
        hideProgress = false,
        hideCurrentProgress,
      },
      error,
      errorData,
    } = this.props;
    let backgroundClass = 'circle--background circle--background1';
    if (userData.questionaries && userData.questionaries.length > 1) {
      const imageChange = userData.questionaries.filter(item => {
        return item.value !== '' && icons.default[item.value.replace(/[, ]+/g, '')] !== undefined;
      });
      backgroundClass = classNames(
        'circle--background', {
          [`circle--background${imageChange.length}`]: imageChange,
        }
      );
    }

    const { currentPageData: { currentPageId } } = currentProgress;
    const Loader = activeSectionData.pages.filter(item => {
      return item.pageId === currentPageId && item.loaderType;
    });

    if (this.state.addedIcon && this.state.addedIcon !== 'icon--animate illustration--startInsurance'
      && document.getElementsByClassName(this.state.addedIcon)
      && document.getElementsByClassName(this.state.addedIcon)[0]) {
      document.getElementsByClassName(this.state.addedIcon)[0].remove();
    }

    let sectionClassLeft;
    if (Loader.length <= 0) {
      sectionClassLeft = 'section--left';
    } else {
      sectionClassLeft = 'section--full';
    }
    const { activeIllustration } = userData;
    const displayIllustration = (illustration) => {
      let imageClassName = '';
      const illustrationFound = activeIllustration && activeIllustration.filter(item => {
        return item.value === illustration.value;
      });
      if (illustrationFound && illustrationFound.length > 0) {
        imageClassName = 'no-animate';
      } else {
        imageClassName = `animate illustration--${illustration.value.replace(/[, ]+/g, '')}`;
        this.state.addedIcon = `icon--animate illustration--${illustration.value.replace(/[, ]+/g, '')}`;
      }
      return (
        <Icon icon={illustration.value.replace(/[, ]+/g, '')} fill="none" className={imageClassName} />
      );
    };
    return (
      <div className="section--container">
        <article className={sectionClassLeft}>
          <div>
            {/* Progress Bar */}
            <CSSTransition
              in={error || !hideProgress}
              timeout={300}
              classNames="fadeIn"
              unmountOnExit
            >
              <aside className="progress">
                <ProgressBar
                  currentProgress={currentProgress}
                  currentSectionId={currentSectionId}
                  finishedSections={finishedSections}
                  packageData={packageData}
                  error={error}
                  sectionOrder={sectionOrder}
                />

                {/* Current Progress */}
                <CSSTransition
                  in={!error && !hideCurrentProgress}
                  timeout={300}
                  classNames="fadeIn"
                  unmountOnExit
                >
                  <CurrentProgress currentProgress={currentProgress} />
                </CSSTransition>
              </aside>
            </CSSTransition>
            <BaseSection
              actions={actions}
              activeSectionData={activeSectionData}
              currentProgress={currentProgress}
              currentSectionId={currentSectionId}
              finishedSections={finishedSections}
              loaderProgress={loaderProgress}
              packageData={packageData}
              price={price}
              userData={userData}
              sectionOrder={sectionOrder}
              error={error}
              errorData={errorData}
            />
          </div>
        </article>
        {Loader.length <= 0 &&
          <article className="section--right">
            <div className={backgroundClass}>
              <div className="section--illustrations">
                <div className="section--border">
                  {userData.questionaries &&
                    userData.questionaries.map((illustration) => {
                      return displayIllustration(illustration);
                    })
                  }
                  <span id="popupIllustration">
                    <Icon icon='popupIllustration' />
                  </span>
                </div>
              </div>
            </div>
          </article>
        }
      </div>
    );
  }
}

export default InsuranceSection;

InsuranceSection.propTypes = {
  activeSectionData: PropTypes.object.isRequired,
  actions: PropTypes.object.isRequired,
  currentProgress: PropTypes.object.isRequired,
  currentSectionId: PropTypes.number.isRequired,
  loaderProgress: PropTypes.number.isRequired,
  finishedSections: PropTypes.array.isRequired,
  packageData: PropTypes.object.isRequired,
  userData: PropTypes.object.isRequired,
  sectionOrder: PropTypes.object.isRequired,
  price: PropTypes.string.isRequired,
  error: PropTypes.bool.isRequired,
  errorData: PropTypes.object.isRequired,
};
